export const pageMeta = {
  home: {
    title: 'Managed IT Services & AI Automation',
    description: 'Managed IT and AI automation serving the Portland metro and Pacific Northwest — team members in Hillsboro, Tigard, Vancouver, McMinnville, and Newberg.',
    canonical: 'https://nexttechconsultants.com',
  },
  services: {
    title: 'Managed IT & AI Automation Services',
    description: 'Two services. One partner. Full outsourced IT department and AI workflow automation for Pacific Northwest businesses.',
    canonical: 'https://nexttechconsultants.com/services',
  },
  managedIT: {
    title: 'Managed IT Services for Pacific Northwest Businesses',
    description: 'Full-service IT department outsourcing for SMBs in Oregon, Washington, and Idaho. 24/7 monitoring, unlimited support, flat monthly rate. No surprise bills.',
    canonical: 'https://nexttechconsultants.com/services/managed-it',
  },
  aiAutomation: {
    title: 'AI Business Automation for Pacific Northwest SMBs',
    description: 'We identify your biggest time drains and build workflow automations that run themselves. ROI-tracked AI implementation for Oregon, Washington, and Idaho businesses.',
    canonical: 'https://nexttechconsultants.com/services/ai-automation',
  },
  aiComparison: {
    title: 'AI Agent Comparison Matrix — Privacy, Plans & Features',
    description: 'Side-by-side comparison of Claude, ChatGPT, Gemini, Copilot, Meta AI, and Grok — privacy defaults, subscription plans, token economics, and supporting policy quotes.',
    canonical: 'https://nexttechconsultants.com/services/ai-automation/compare',
  },
  about: {
    title: 'About NextTech Consultants — Portland Metro MSP',
    description: 'Six-person team of certified IT professionals serving the Portland metro and Pacific Northwest. Apple, AWS, and Microsoft 365 certified. 11 years, 100+ clients.',
    canonical: 'https://nexttechconsultants.com/about',
  },
  pricing: {
    title: 'Managed IT Pricing — Starting at $219/Seat/Month',
    description: 'Simple flat-rate pricing. No hourly billing, no surprise costs. Everything included: unlimited support, monitoring, software, and migrations.',
    canonical: 'https://nexttechconsultants.com/pricing',
  },
  contact: {
    title: 'Contact NextTech Consultants — Book a Free Discovery Call',
    description: '30-minute call, no obligation. Talk to Josiah about your tech challenges and get a clear picture of what managed IT + AI automation would cost.',
    canonical: 'https://nexttechconsultants.com/contact',
  },
  blog: {
    title: 'IT & AI Automation Blog for Pacific Northwest Businesses',
    description: 'Practical tech guidance for Oregon, Washington, and Idaho SMBs — no jargon, no vendor pitches. Cybersecurity, AI automation, and managed IT insights.',
    canonical: 'https://nexttechconsultants.com/blog',
  },
  privacy: {
    title: 'Privacy Policy — NextTech Consultants',
    description: 'How NextTech Consultants collects, uses, and protects your personal information. SMS opt-out and data practices.',
    canonical: 'https://nexttechconsultants.com/privacy',
  },
  sms2faTerms: {
    title: 'SMS Terms — One-Time Passcode (2FA)',
    description: 'Mobile terms of service for NextTech Consultants one-time passcode (2FA) SMS program. Opt-out, support contact, and message frequency.',
    canonical: 'https://nexttechconsultants.com/sms-terms',
  },
  smsMarketingTerms: {
    title: 'SMS Marketing Terms — Promotional Messages',
    description: 'Mobile terms of service for NextTech Consultants marketing SMS program, including opt-out instructions, support contact, message frequency, and required disclosures.',
    canonical: 'https://nexttechconsultants.com/sms-marketing-terms',
  },
  security: {
    title: 'Cybersecurity Certification for Pacific Northwest Businesses — NextTech Consultants',
    description: 'NextTech Consultants delivers SPECTRA-certified endpoint security for Oregon, Washington, and Idaho businesses. Third-party verified protection for legal, healthcare, and professional services firms.',
    canonical: 'https://nexttechconsultants.com/security',
  },
  hubSupport: {
    title: 'HUB Support — Report an Issue or Request an Enhancement',
    description: 'Submit a bug report or enhancement request for the HUB EHR platform. NextTech Consultants support form for issues and feature requests.',
    canonical: 'https://nexttechconsultants.com/hub-support',
  },
  /** noindex page — canonical for sharing only; omit from sitemap */
  masterServiceAgreement: {
    title: 'Master Services Agreement',
    description: 'Master services agreement governing services provided by NextTech Consultants.',
    canonical: 'https://nexttechconsultants.com/nexttech-consultants-master-service-agreement',
  },
}
